// 05-11 (auditoría, QA M5) — al cerrar el chat, el foco vuelve a donde se abrió (la fila o la mesa), no a <body>. Antes,
// tras Esc, el foco caía en la nada: lo que Pau tecleaba se perdía y el siguiente Tab empezaba desde arriba.
//
// Quien abre un chat desde un sitio con foco (la fila de la lista, una cara del riel, una mesa) lo apunta ANTES de abrir;
// al cerrarlo, si el foco se ha quedado en nada, vuelve ahí. Si aquello ya no está (o el chat se abrió con Ctrl+K o
// Alt+↓), a la fila del agente que estaba abierto. Si al cerrar algo ya tiene el foco (otra ventana), no se le quita.
import { useOficinaStore } from '../store';

let alAbrir: HTMLElement | null = null;

/** Apunta lo que tiene el foco al abrir un chat (solo el primero: pasar de un chat a otro conserva el de origen). */
export function recordarFocoAlAbrir(): void {
  if (useOficinaStore.getState().chatAbierto) return;
  const el = document.activeElement;
  alAbrir = el instanceof HTMLElement && el !== document.body ? el : null;
}

const FILA_ABIERTA = '[data-testid="filas-equipo"] button[aria-current="true"], [data-testid="riel-equipo"] button[aria-current="true"]';

/** Llamar al cerrar el chat (antes de que se desmonte): cuando ya no está, devuelve el foco a su sitio. */
export function devolverFocoAlCerrar(): void {
  const origen = alAbrir?.isConnected ? alAbrir : null;
  const destino = origen ?? document.querySelector<HTMLElement>(FILA_ABIERTA);
  alAbrir = null;
  setTimeout(() => {
    const ahora = document.activeElement;
    if (ahora && ahora !== document.body) return;
    if (destino?.isConnected) destino.focus({ preventScroll: true });
  }, 0);
}
